import { JimboResponse } from '@models';
import { createSlice } from '@reduxjs/toolkit';

interface ErrorLogItem extends JimboResponse {
  id: number;
}

interface ErrorLogState {
  errors: ErrorLogItem[];
}

const getInitialState = (): ErrorLogState => {
  const savedState = localStorage.getItem('error-log');

  if (savedState) {
    return JSON.parse(savedState) as ErrorLogState;
  }

  return { errors: [] } as ErrorLogState;
};

const setSavedState = (state: ErrorLogState) => {
  localStorage.setItem('error-log', JSON.stringify(state));
};

export const errorLogSlice = createSlice({
  name: 'error-log',
  initialState: { value: getInitialState() },
  reducers: {
    addErrorToLog: (state, action: { type: string; payload: JimboResponse }) => {
      const error = { ...action.payload, id: state.value.errors.length + 1 };

      state.value.errors.push(error);
      setSavedState({ errors: [...state.value.errors, error] });
    },
  },
});

export const { addErrorToLog } = errorLogSlice.actions;

export default errorLogSlice.reducer;
